import React, { useEffect, useState, FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Logo from "../../../logo.png";
import { Formik } from "formik";
import LoginBanner from "../../../assets/images/login-banner.png";
import { loginWithUserNameAndPassword } from "../../../services/authService";
import SnackbarToast from "../../../components/common/SnackBar";
import Loader from "../../../components/common/Loader";
import storage from "../../../helpers/storage";
import InputText from "../../../components/common/InputText";
import InputPassword from "../../../components/common/InputPassword";
// import { SignUpStepOneSchema, SignUpStepTwoSchema, SignUpStepThreeSchema } from '../../../validations/Auth';
// import ReCAPTCHA from 'react-google-recaptcha';

interface ISignUpData {
  FirstName: String;
  LastName: String;
  Email: String;
  CompanyName: String;
  PhoneNumber: String;
  CellNumber: String;
  Address: String;
  City: String;
  State: String;
  Zip: String;
  Password: String;
  ConfirmPassword: String;

  BillingContactName: String;
  BillingContactEmail: String;
  BillingCellNumber: String;
  BillingAddress: String;
  BillingCity: String;
  BillingState: String;
  BillingZip: String;
  YardSameAsBilling: String;
  YardAddress: String;
  YardCity: String;
  YardState: String;
  YardZip: String;

  DecalContactName: String;
  DecalContactEmail: String;
  DecalCellNumber: String;
  DecalAddress: String;
  DecalCity: String;
  DecalState: String;
  DecalZip: String;
}

export const SignUp = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const [currentstep, setCurrentStep] = useState(0);
  // const [userData, setUserData]:any = useState({emailId:"test@test.com"});
  const [showSnackBar, setshowSnackBar]: any = useState({
    show: false,
    message: "",
    severity: "",
  });
  // const rememberMe: any = storage.getData('remember-me');

  const initialAllValues = {
    FirstName: "",
    LastName: "",
    Email: "",
    CompanyName: "",
    PhoneNumber: "",
    CellNumber: "",
    Address: "",
    City: "",
    State: "",
    Zip: "",
    Password: "",
    ConfirmPassword: "",

    BillingContactName: "",
    BillingContactEmail: "",
    BillingCellNumber: "",
    BillingAddress: "",
    BillingCity: "",
    BillingState: "",
    BillingZip: "",
    YardSameAsBilling: "",
    YardAddress: "",
    YardCity: "",
    YardState: "",
    YardZip: "",

    DecalContactName: "",
    DecalContactEmail: "",
    DecalCellNumber: "",
    DecalAddress: "",
    DecalCity: "",
    DecalState: "",
    DecalZip: "",
  };
  const [signUpData, setsignUpData] = useState<ISignUpData>(initialAllValues);

  const handleClose = () => {
    setshowSnackBar({
      show: false,
      message: "",
      severity: "",
    });
  };
  const recaptchaRef = React.createRef();
  function onChange() {
    // console.log("Captcha value:");
  }

  useEffect(() => {
    if (storage.getToken() != null) {
      return navigate("app/dashboard");
    }
  }, [navigate]);

  const onChangeCheckbox = (event: any) => {
    setIsChecked(event.target.checked);
  };

  const handleNextStep = (newData: any) => {
    // setsignUpData({newData});
    setsignUpData({ ...signUpData, ...newData });
    

    setCurrentStep((prev) => prev + 1);
    
  };

  const handlePrevStep = (newData: any) => {
    // setSignUpData(prev => ({...prev, ...newData}));
    setCurrentStep((prev) => prev - 1);
    
  };

  const [steps, setSteps] = useState([
    // <StepOne data={signUpData} next={handleNextStep} />,
    // <StepTwo data={signUpData} next={handleNextStep} prev={handlePrevStep}/>,
    // <StepThree data={signUpData} prev={handlePrevStep} next={handleNextStep}/>
  ]);

  return (
    <>
      <Row className="g-0 vh-100 position-relative">
        <Col sm className="h-100">
          <div className="h-100 overflow-auto p-4 p-md-5 text-center w-100">
            <Row className="justify-content-center g-0">
              <Col lg={10} xl={7} xxl={6}>
                <div className="mb-5 pb-2">
                  <Link to="/" className="d-inline-block">
                    <Image
                      className="img-fluid"
                      src={Logo}
                      alt="Logo"
                      width={174}
                      height={107}
                    />
                  </Link>
                </div>
                <h1 className="d-inline-block fw-bold h4 mb-1 mt-1 pt-2 w-100">
                  Welcome To Safety Inspection
                </h1>
                <h4 className="fs-18 fw-normal">Pay for Performance</h4>

                {steps[currentstep]}
              </Col>
            </Row>
          </div>
        </Col>
        <Col sm className="mobileBannerActive h-100">
          <Image
            className="h-100 object-fit-cover w-100"
            src={LoginBanner}
            alt="Login Banner"
          />
        </Col>
      </Row>
      <SnackbarToast showSnackBar={showSnackBar} handleClose={handleClose} />
      <Loader isLoading={loading} />
    </>
  );
};

// const StepOne = (props:any) => {

//     const submitForm =  (values:any)  => {
//         props.next(values);
//         console.log("Submit Step 1",values);
//     }
//     return (
//         <>Step 1
//             <Formik
//                 validationSchema={SignUpStepOneSchema}
//                 initialValues={props.data}
//                 onSubmit={(values, actions) => {
//                     actions.setSubmitting(false);
//                     submitForm(values)
//                 }}
//             >

//                 {({
//                     handleSubmit,
//                     handleChange,
//                     handleBlur,
//                     values,
//                     errors,
//                     touched,
//                 }) => (
//                     <Form className="text-start pt-4" noValidate onSubmit={handleSubmit}>
//                         {/* <PermissionsGate
//                             scopes={[SCOPES.canEdit]}
//                         > */}
//                       {/*{ JSON.stringify(props.data) }*/}
//                         <InputText controlId="Email" label='Email' placeholder="Enter Email" touched={touched.Email} handleBlur={handleBlur} handleChange={handleChange} errorsField={errors.Email} value={values.Email} />

//                         <InputPassword controlId="Password" label='Password' placeholder="Enter Password" touched={touched.Password} handleBlur={handleBlur} handleChange={handleChange} errorsField={errors.Password} value={values.Password} />
//                         {/* </PermissionsGate> */}

//                         {/*<Form.Group className="mb-3 pb-1">
//                             <Row xs="auto" className="align-items-center justify-content-between gx-0">
//                                 <Col>
//                                     <Form.Check id="rememberCheck" checked={isChecked} onChange={onChangeCheckbox} className="fs-15" type="checkbox" label="Remember Me" />
//                                 </Col>
//                                 <Col>
//                                     <Link className="fw-bold text-decoration-none" to="/forgot-password">Forgot Password?</Link>
//                                 </Col>
//                             </Row>
//                         </Form.Group>*/}
//                         {/*<ReCAPTCHA
//                             sitekey="6LdV34wkAAAAAInAvVlA3LuU3zmwTNwGcZqkUoPB"
//                             onChange={onChange}
//                         />*/}
//                         <Button className="fw-bold w-100" variant="primary" type="submit">
//                             Next
//                         </Button>
//                     </Form>
//                 )}
//             </Formik>
//         </>
//     )
// }

// const StepTwo = (props:any) => {
//     const submitForm = (values:any) => {
//         props.next(values);
//         console.log("step 2 props", values);
//     }
//     return (
//         <>Step 2
//             <Formik
//                 validationSchema={SignUpStepTwoSchema}
//                 initialValues={props.data}
//                 onSubmit={(values, actions) => {
//                     actions.setSubmitting(false);
//                     submitForm(values)
//                 }}
//             >
//                 {({
//                     handleSubmit,
//                     handleChange,
//                     handleBlur,
//                     values,
//                     errors,
//                     touched,
//                 }) => (
//                     <Form className="text-start pt-4" noValidate onSubmit={handleSubmit}>
//                         {/* <PermissionsGate
//                             scopes={[SCOPES.canEdit]}
//                         > */}
//                         {/*{ JSON.stringify(props.data) } 12132*/}
//                         <InputText controlId="BillingContactEmail" label='Billing Contact Email' placeholder="Enter Billing Contact Email" touched={touched.BillingContactEmail} handleBlur={handleBlur} handleChange={handleChange} errorsField={errors.BillingContactEmail} value={values.BillingContactEmail} />

//                         {/*<InputPassword controlId="Password" label='Password' placeholder="Enter Password" touched={touched.Password} handleBlur={handleBlur} handleChange={handleChange} errorsField={errors.Password} value={values.Password} />*/}
//                         {/* </PermissionsGate> */}

//                         {/*<Form.Group className="mb-3 pb-1">
//                             <Row xs="auto" className="align-items-center justify-content-between gx-0">
//                                 <Col>
//                                     <Form.Check id="rememberCheck" checked={isChecked} onChange={onChangeCheckbox} className="fs-15" type="checkbox" label="Remember Me" />
//                                 </Col>
//                                 <Col>
//                                     <Link className="fw-bold text-decoration-none" to="/forgot-password">Forgot Password?</Link>
//                                 </Col>
//                             </Row>
//                         </Form.Group>*/}
//                         {/*<ReCAPTCHA
//                             sitekey="6LdV34wkAAAAAInAvVlA3LuU3zmwTNwGcZqkUoPB"
//                             onChange={onChange}
//                         />*/}
//                         <Button className="fw-bold w-100" variant="default" type="button" onClick={ () => props.prev(values) }>
//                             Previous
//                         </Button>
//                         <Button className="fw-bold w-100" variant="primary" type="submit">
//                             Next
//                         </Button>
//                     </Form>
//                 )}
//             </Formik>
//         </>
//     )
// }

// const StepThree = (props:any) => {
//     const submitForm = (values:any) => {
//         props.next(values);
//     }

//     return (
//         <>Step 3
//             <Formik
//                 validationSchema={SignUpStepThreeSchema}
//                 initialValues={props.data}
//                 onSubmit={(values, actions) => {
//                     actions.setSubmitting(false);
//                     submitForm(values)
//                 }}
//             >
//                 {({
//                     handleSubmit,
//                     handleChange,
//                     handleBlur,
//                     values,
//                     errors,
//                     touched,
//                 }) => (
//                     <Form className="text-start pt-4" noValidate onSubmit={handleSubmit}>
//                         {/* <PermissionsGate
//                             scopes={[SCOPES.canEdit]}
//                         > */}
//                         <InputText controlId="DecalContactEmail" label='DecalContactEmail' placeholder="Enter DecalContactEmail" touched={touched.DecalContactEmail} handleBlur={handleBlur} handleChange={handleChange} errorsField={errors.v} value={values.DecalContactEmail} />

//                         <Button className="fw-bold w-100" variant="primary" type="button" onClick={ () => props.prev(values) }>
//                             Previous
//                         </Button>
//                         <Button className="fw-bold w-100" variant="primary" type="submit">
//                             Submit
//                         </Button>
//                     </Form>
//                 )}
//             </Formik>
//         </>
//     )
// }
